import React, { useEffect, useState, useContext } from 'react'
import Input from '../Atoms/Input'
import NumericInput from 'react-numeric-input'
import './Lieferstelle.sass'
import { useSessionStorage } from '../Hooks/useSessionStorage'
import Trash from '../../Images/icon-delete.svg'

import { ProductContext } from '../Context/Context'

const WeitereLieferstelle = (props) => {

	const {
			region,
			bestellung,
			setBestellung,
			setLoading,
	} = useContext(ProductContext)

	const [errors, setErrors] = useState(false)
	const [amount, setAmount] = useSessionStorage('no__' + props.unique, 500)
	const [plz, setPlz] = useSessionStorage('no__plz__' + props.unique, '')
	const [lieferstelle, setLieferstelle] = useSessionStorage('no__lieferstelle_' + props.unique, {
		plz: '',
		liefermenge: 500
	})




	// const updateOrder = () => { 

	// }

	useEffect(() => {

		if (plz === '') { 

			setBestellung(prev => { 
				return {
					...prev,
					anzahlLieferstellen: prev.anzahlLieferstellen,
				lieferstellen: {
					...prev.lieferstellen,
					[props.unique]: {
						plz: errors  ? false : plz,
						liefermenge: lieferstelle.liefermenge
					}
				},
				}
			})
			return
		}

			setBestellung(prev => ({
				...prev,
				anzahlLieferstellen: prev.anzahlLieferstellen,
				lieferstellen: {
					...prev.lieferstellen,
					[props.unique]: {
						plz: errors || plz === '' ? false : plz,
						liefermenge: lieferstelle.liefermenge
					}
				},
				totals: {
					...prev.totals,
					lieferstelle: prev.settings.aufschlag_lieferstelle * (prev.anzahlLieferstellen - 1),
					termin: parseFloat(props.time.value)
				},
				contact: {
					...prev.contact,
					[props.unique]: {
						first: prev.contact[props.unique] ? prev.contact[props.unique].first : '',
						last: prev.contact[props.unique] ? prev.contact[props.unique].last : '',
						company: prev.contact[props.unique] ? prev.contact[props.unique].company : '',
						phone: prev.contact[props.unique] ? prev.contact[props.unique].phone : '',
						street: prev.contact[props.unique] ? prev.contact[props.unique].street : '',
						street_number: prev.contact[props.unique] ? prev.contact[props.unique].street_number : '',
						city: prev.contact[props.unique] ? prev.contact[props.unique].city : '',
						plz: lieferstelle.plz === '' ? false : lieferstelle.plz,
						birthday: '',
						clientId: prev.contact[props.unique] ? prev.contact[props.unique].clientId : '',
						billing: {
							billing: false,
							first: '',
							last: '',
							company: '',
							email: '',
							phone: '',
							street: '',
							street_number: '',
							plz: '',
							city: ''
						},
						payment: {
							method: prev.contact[props.unique] ? prev.contact[props.unique].payment.method : '',
							price: prev.contact[props.unique] ? prev.contact[props.unique].payment.method : 0,
							clientId: prev.contact[props.unique] ? prev.contact[props.unique].payment.clientId : false
						},
					}
				}

			})
			)
		
	
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lieferstelle])

	const getPlzRegion = async () => { 

		setLoading(true)
		// console.log('PLZ RENDER');

		const bereich = await fetch(`${props.api}/wp-json/postleitzahlen/plz?id=${plz}`).then(res => {
			return res.json()
		}).catch(err => console.log(err))

		if (bereich.length) {
			if (Object.values(bereich[0])[0].region !== region.region) {
				setErrors(prev => 'Die beiden Lieferstellen müssen sich im gleichen Liefergebiet befinden')
			} else {
				setLieferstelle(prev => {
					return {
						...prev,
						plz: plz,
						liefermenge: amount
					}
				})
				setErrors(prev => false)
			 }
		} else { 
			setErrors(prev => 'Bitte haben Sie Verständnis dafür, dass wir in der von Ihnen angegebenen Region leider keine Lieferung vornehmen können. Für Rückfragen kontaktieren Sie uns gerne.')
		}
		setLoading(prev => false)
	}

	const handleUpdate = (num) => {
		setAmount(prev => num)
		setLieferstelle(prev => ({
			...prev,
			liefermenge: num
		}))
	}


	const handleDelete = () => {
		const lieferstellen = bestellung.lieferstellen
		const liefermenge = lieferstellen[props.unique].liefermenge
		delete lieferstellen[props.unique]
		delete bestellung.contact[props.unique]
		props.handleUpdate(prev => ({
			...bestellung,
			totals: {
				...bestellung.totals,
				totalAmount: bestellung.totals.totalAmount - liefermenge,
				termin: parseFloat(props.time.value),
				// express: prop
				lieferstelle: bestellung.settings.aufschlag_lieferstelle * (bestellung.anzahlLieferstellen - 2),
			},
			lieferstellen: lieferstellen,
			anzahlLieferstellen: bestellung.anzahlLieferstellen - 1 
		}))
	}


	const handlePlzChange = e => {
		setPlz(prev => e.target.value)
		// e.target.value.length === 5 && getPlzRegion(e)
	}

	useEffect(() => {
		if (plz.length === 5) {
			getPlzRegion(plz)
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [plz])

	return (
		<div className="no__lieferstelle">
			<h3>Lieferstelle {props.number}</h3>
			<div className="no__gridcontent">
				<div>
					<Input
						id={`plz_${props.unique}`}
						type='number'
						required={true}
						disabled={false}
						changeEvent={true}
						label='PLZ eingeben'
						value={plz}
						handleChange={e => handlePlzChange(e)}
					/>
						{errors && 
					<p className="error">{errors}</p>
				}
				</div>
			

			{lieferstelle.plz && !errors && <div className="no__input-group">
				<label>Lieferumfang in Litern*</label>
				<NumericInput
					className="no__input-number"
					value={amount}
					min={500}
					step={500}
					precision={0}
					format={num => num + ' L'}
					size={5}
					mobile
					onFocus={(e) => e.target.blur()}
					onChange={handleUpdate}
				/>
			
			</div>}
			
				<button onClick={handleDelete} className="no__delete"><img src={Trash} alt="Löschen" /></button>
			</div>
		</div>
	)
}

export default WeitereLieferstelle
